/**
 * Метка статуса, производства, техкарты и оплаты в таблице планов.
 * Вынесено из `components/PlansTable.tsx` (нарезка 14.10.26).
 */

export function Badge({
  tone,
  text,
  title,
}: {
  tone: string | undefined;
  text: string | null;
  /** Пояснение словами: «нет» на экране закупки без него читается двояко. */
  title?: string;
}) {
  if (!text) return <span className="text-fg-faint">—</span>;
  return (
    <span
      title={title}
      className={
        // nowrap обязателен: «Нужны изменения» переносится на две строки и
        // ломает высоту строки, а с ней — расчёт виртуализатора.
        "inline-flex h-[21px] items-center gap-1.5 whitespace-nowrap rounded-full border px-2 text-[11.5px] font-medium " +
        (tone ?? "text-fg-muted bg-neutral-bg border-border")
      }
    >
      <span className="size-[5px] rounded-full bg-current" />
      {text}
    </span>
  );
}
